import {
  collection,
  deleteDoc,
  Timestamp,
  doc,
  FieldValue,
  getDoc,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { firestore, functions } from "../../@common/firebase/firebase";
import { deleteObject, ref as storageRef } from "firebase/storage";
import sizeof from "firestore-size";
import { httpsCallable } from "firebase/functions";

//Types

export interface CategoryType {
  status: string;
  startingBalance: number;
  secretBalance: number;
  label: string;
  id: string;
  icon: string;
  created: string;
  deleted?: string;
  budget: { [timestamp: string]: number };
}

export interface BlockType {
  status: string;
  name: string;
  created: string;
  deleted?: string;
  categories: CategoryType[];
}

export interface UserType {
  name: string;
  lastModified?: Timestamp | FieldValue;
  id: string;
  household: string;
  budgetList: string[];
  blocks: BlockType[];
  invitation?: InvitationType;
}

export interface InvitationType {
  inviter: string;
  inviterName: string;
  invitee: string;
  householdId: string;
  householdName: string;
}

export interface MemberType {
  id: string;
  name: string;
}

export interface HouseholdType {
  owner: string;
  name: string;
  lastModified?: Timestamp | FieldValue;
  id: string;
  currency: string;
  members: MemberType[];
}

const createFirebaseUser = async (userId: string, name: string) => {
  const newUser: UserType = {
    blocks: [],
    id: userId,
    name: name,
    household: "",
    budgetList: [],
    lastModified: serverTimestamp(),
  };

  await setDoc(doc(firestore, "users", userId), newUser);
  return newUser;
};

const createFirebaseHousehold = async (newHousehold: HouseholdType) => {
  const ref = doc(collection(firestore, "households"));
  let createdHousehold = newHousehold;
  createdHousehold.id = ref.id;
  createdHousehold.lastModified = serverTimestamp();

  await setDoc(ref, createdHousehold);
  return createdHousehold;
};

const updateFirebaseBlocks = async (userId: string, blocks: BlockType[]) => {
  const userref = doc(firestore, "users", userId);
  const newblocks = [...blocks];
  const res = await updateDoc(userref, {
    blocks: newblocks,
    lastModified: serverTimestamp(),
  });
  return res;
};

const updateFirebaseUser = async (user: UserType) => {
  const userref = doc(firestore, "users", user.id);
  let newUser = { ...user };
  newUser.lastModified = serverTimestamp();

  const res = await updateDoc(userref, newUser);
  return res;
};

const deleteFirebaseUser = async (userId: string, householdId: string) => {
  const handleFirebaseDelete = httpsCallable(
    functions,
    "handleInvitationAccept"
  );
  await handleFirebaseDelete({ userId: userId, householdId: householdId });
  return true;
};

const updateFirebaseHousehold = async (household: HouseholdType) => {
  const householdref = doc(firestore, "households", household.id);
  let newHousehold = { ...household };
  newHousehold.lastModified = serverTimestamp();
  const res = await updateDoc(householdref, newHousehold);
  return res;
};

const getFirebaseUser = async (userId: string) => {
  const ref = doc(firestore, "users", userId);
  const user = await getDoc(ref);
  const userData = user.data();
  //  console.log("Userdata:")
  // console.log(userData)
  //   console.log(sizeof(userData))

  let household = null;

  if (userData?.household && userData?.household.length > 0) {
    const householRef = doc(firestore, "households", userData.household);
    const householdDoc = await getDoc(householRef);
    household = householdDoc.data();
  }

  if (household === undefined) household = null;

  return { user: userData, household: household };
};

export {
  createFirebaseUser,
  deleteFirebaseUser,
  getFirebaseUser,
  createFirebaseHousehold,
  updateFirebaseBlocks,
  updateFirebaseUser,
  updateFirebaseHousehold,
};
